export default __webpack_public_path__ + "static/media/425twofloorplan.c115259e.svg";